import {
    Button,
    Modal,
    FormGroup,
    FormControl,
    ControlLabel,
    Row,
    Col,
    Table
} from 'react-bootstrap';
import { Translate } from '../../shared/LanguageService';
import { connect } from 'react-redux';
import { assign } from '../../shared/Assign';
import AutoUpdateListTrigger from '../../shared/AutoUpdateListTrigger';
import * as Actions from './actions/PhotoOrderListActions';
import ProductPropertiesIcons from '../propertyIcons/ProductPropertiesIcons';
import * as React from 'react';
import DateTimeView from '../localDate/DateTimeView';
import Loader from 'react-loader';
import moment from 'moment';

interface IUneditedFuturePhotoOrdersListActions {
    getUneditedFuturePhotoOrders: () => any;
}

interface IUneditedFuturePhotoOrdersListProps {
    actions: IUneditedFuturePhotoOrdersListActions;
    futureOrders: IFutureOrderAggregate[];
}

interface IFutureOrderAggregate {
    expectedEditingDate: Date;
    numberOfOrders: number;
    numberOfImages: number;
    numberOfExpresses: number;
    numberOfBlueSkies: number;
    numberOfInteriorBlueSkies: number;
}

class UneditedFuturePhotoOrderList extends React.Component<
    IUneditedFuturePhotoOrdersListProps,
    any
> {
    private _updateListTrigger: AutoUpdateListTrigger;

    constructor(props: IUneditedFuturePhotoOrdersListProps, context: any) {
        super(props, context);
        this.state = {
            futureOrders: [],
            isLoading: false
        };

        this.getUneditedFuturePhotoOrders = this.getUneditedFuturePhotoOrders.bind(this);
        this._updateListTrigger = new AutoUpdateListTrigger(this.getUneditedFuturePhotoOrders);
    }

    UNSAFE_componentWillReceiveProps(
        nextProps: IUneditedFuturePhotoOrdersListProps,
        nextState: any
    ) {
        this.setState({ futureOrders: assign([], nextProps.futureOrders) });
    }

    UNSAFE_componentWillMount() {
        this.props.actions.getUneditedFuturePhotoOrders();
        this._updateListTrigger.subscribe();
    }

    componentWillUnmount() {
        this._updateListTrigger.unsubscribe();
    }

    getUneditedFuturePhotoOrders() {
        if (!this.state.isLoading) {
            this.setState({ isLoading: true });
            this.props.actions
                .getUneditedFuturePhotoOrders()
                .then(() => {
                    this.setState({ isLoading: false });
                })
                .catch((error: any) => {
                    this.setState({ isLoading: false });
                });
        }
    }

    render() {
        return (
            <div>
                <h1>{Translate('unedited-future-orders/header')}</h1>
                <Table className="order-table" responsive>
                    <thead>
                        <tr>
                            <th>
                                {Translate(
                                    'unedited-future-orders/table/tableheader/expected-editing-date'
                                )}
                            </th>
                            <th>
                                {Translate(
                                    'unedited-future-orders/table/tableheader/number-of-orders'
                                )}
                            </th>
                            <th>
                                {Translate(
                                    'unedited-future-orders/table/tableheader/number-of-images'
                                )}
                            </th>
                            <th>{Translate('unedited-future-orders/table/tableheader/express')}</th>
                            <th>
                                {Translate('unedited-future-orders/table/tableheader/blue-skye')}
                            </th>
                            <th>
                                {Translate(
                                    'unedited-future-orders/table/tableheader/blue-skype-interior'
                                )}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.props.futureOrders.map((futureOrder: any, index: number) => (
                            <tr key={'future-orders-' + index}>
                                <td>{moment(futureOrder.expectedEditingDate).format('L')}</td>
                                <td>{futureOrder.numberOfOrders}</td>
                                <td>{futureOrder.numberOfImages}</td>
                                <td>{futureOrder.numberOfExpresses}</td>
                                <td>{futureOrder.numberOfBlueSkies}</td>
                                <td>{futureOrder.numberOfInteriorBlueSkies}</td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>
        );
    }
}

function mapStateToProps(state: any, ownProps: any) {
    return {
        futureOrders: state.futureOrders as IFutureOrderAggregate
    };
}

function mapDispatchToProps(dispatch: any) {
    return {
        actions: {
            getUneditedFuturePhotoOrders: () => dispatch(Actions.getUneditedFuturePhotoOrders())
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(UneditedFuturePhotoOrderList);
